import { useState, useContext } from "react";
import EditorInput from "layouts/Flow Designer/components/ComponentActionsGenerator/components/EditorInput";
import SoftTypography from "components/SoftTypography";
import { EditorExpansion } from "../../../../EditorExpansion";
import { FormFieldsContext } from "layouts/Flow Designer/context";

export const HtmlEditor = ({ isFlowActive, allowEditWorkflow }) => {
  const [editorExpanded, setEditorExpanded] = useState(false);
  const formRef = useContext(FormFieldsContext);

  const handleEditorChange = (value) => {
    const originalValue = value;
    const parsedQuery = originalValue.replace(/\\r\\n/g, "");

    formRef?.setFieldValue("payload", parsedQuery);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        zIndex: editorExpanded ? 10 : 0
      }}
    >
      <SoftTypography
        sx={{ paddingLeft: 2, paddingBottom: 1 }}
        variant="caption"
        fontWeight="light"
        color="dark"
      >
        Response
      </SoftTypography>
      <div
        style={{
          inset: editorExpanded ? "0" : "initial",
          position: editorExpanded ? "fixed" : "relative"
        }}
      >
        <EditorInput
          fieldValue={formRef?.values?.payload}
          language="html"
          onChange={handleEditorChange}
          options={{
            wordWrap: "off",
            scrollbar: {
              vertical: "auto",
              horizontal: "auto",
              verticalScrollbarSize: 8
            },
            readOnly: isFlowActive || !allowEditWorkflow
          }}
          height={editorExpanded ? "100%" : "300px"}
        />
        <EditorExpansion
          isExpanded={editorExpanded}
          handleExpansion={() => setEditorExpanded((prev) => !prev)}
        />
      </div>
    </div>
  );
};
